<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <smr-stylist-picker
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      [stylistID]="tip.stylistID"
      cssClass="smr-stylist-picker-for-tip"
    >
    </smr-stylist-picker>
    <!--     <ion-title>
      Tip
    </ion-title> -->
  </ion-toolbar>
</ion-header>

<ion-content #content>
  <form class="ion-padding" [formGroup]="tipForm2" (ngSubmit)="save()">
    <!-- <ion-item>
      <ion-label stacked>Tip: </ion-label>
      <ion-input type="number" placeholder="0" name='' formControlName='tip' clearInput></ion-input>
    </ion-item>
-->
    <!-- <div class="input-wrapper ion-padding">
      <input class="text-input text-input-md sm-input-border sm-input-bigtext" placeholder="{{ 0 | salonMonsterCurrency }}" type="text" [formControl]="tipField2" [textMask]="{mask: mask}" />
    </div> -->
    <ion-item lines="none">
      <ion-input
        [maskito]="currencyMask"
        [maskitoElement]="maskPredicate"
        [formControl]="tipField2"
        placeholder="{{ 0 | salonMonsterCurrency }}"
      >
      </ion-input>
    </ion-item>

    <ion-item *ngIf="!tipField2.valid && submitted">
      <p *ngIf="tipField2.hasError('required')" class="sm-error">
        Oops, a tip is required.
      </p>
    </ion-item>
  </form>
  <ion-input type="hidden" class="hidden-input"></ion-input>

  <ion-button
    expand="block"
    fill="clear"
    color="danger"
    *ngIf="showRemoveButton"
    (click)="remove()"
    >Remove</ion-button
  >
</ion-content>

<ion-footer class="ion-no-border ion-no-margin">
  <ion-button
    expand="block"
    color="primary"
    class="ion-no-margin"
    (click)="save()"
  >
    Save
  </ion-button>
</ion-footer>
